import { ReactNode } from 'react';
import { MenuListPages, MobileFullscreenPanel } from '@/shared/components/export';
import { useUserMenuItems } from '@/app/dashboard/hooks/use-user-menu-items';
import { ChatKeysModal } from '@/core/chat/export';
import { getBrandLogo } from '@/shared/theme/export';
import '@/shared/theme/navbar-buttons.scss';
import styles from './mobile-hamburger-menu.module.css';

// "Notification sound" doesn't apply to mobile — everything else from the
// desktop user menu (Settings, Reader, Text size, Toggle features, Chat
// activation, Install, Logout) carries over unchanged.
const EXCLUDED_KEYS = ['mute'];

export default function MobileHamburgerMenu({
  notificationSoundOn,
  setNotificationSoundOn,
  activeWidgetContent,
  onOpenWidgetSelector,
  onClose,
}: {
  notificationSoundOn: boolean;
  setNotificationSoundOn: (on: boolean) => void;
  /** The currently-selected widget's icon+title (its headerPanel), shown on the Widgets button. */
  activeWidgetContent?: ReactNode;
  onOpenWidgetSelector: () => void;
  onClose: () => void;
}) {
  const { items, showChatKeysModal, setShowChatKeysModal } = useUserMenuItems({
    notificationSoundOn,
    setNotificationSoundOn,
  });

  const menuItems = items.filter(item => !EXCLUDED_KEYS.includes(item.key));

  return (
    <MobileFullscreenPanel
      header={<img alt="logo" src={getBrandLogo()} height={24} />}
      headerDivider={false}
      headerClassName={styles.headerRow}
      closeButtonClassName="btn btn-outline-primary-500 btn-sm navbar-btn navbar-btn-square"
      onClose={onClose}
    >
      <button type="button" className={styles.widgetsButton} onClick={onOpenWidgetSelector}>
        {activeWidgetContent ?? 'Widgets'}
      </button>

      {/* No close-on-select here: the other actions (Settings, Chat, Install)
          already open their own overlay on top — leaving this menu underneath
          is fine, and Logout navigates away regardless. */}
      <div className={styles.menuItems}>
        <MenuListPages items={menuItems} />
      </div>
      <ChatKeysModal
        showChatKeysModal={showChatKeysModal}
        setShowChatKeysModal={setShowChatKeysModal}
      />
    </MobileFullscreenPanel>
  );
}
